import './Slider.css'
import React, { Component } from 'react'

class Slider extends Component {
    state = {
        activeSlide: 1
    }

    componentDidMount() {
        setInterval(this.handleInterval, 7000)
    }

    componentWillUnmount() {
        clearInterval(this.handleInterval)
    }

    handleInterval = ()  => {
        const { slides } = this.props

        const { activeSlide } = this.state
        const nextIndex = activeSlide + 1 >= slides.length ? 0 : activeSlide + 1

        this.setState({
            activeSlide: nextIndex
        })

    }

    render() {
        const { activeSlide } = this.state
        const { slides } = this.props
        
        const prevSlide = activeSlide - 1 < 0 ? slides.length - 1 : activeSlide - 1
        const nextIndex = activeSlide + 1 >= slides.length ? 0 : activeSlide + 1

        return <div className='slider'>
            {slides.map(({ name, title, content, image }, index) =>
                <div 
                    className={`slide ${
                        activeSlide === index ? 'active' : ''
                    }${
                        prevSlide === index  ? 'slide-prev' : ''
                    }${
                        nextIndex === index ? 'slide-next' : ''
                    }`} 
                    key={index}
                    onClick={() => this.setState({ activeSlide: index })}
                >
                    {image && <img src={image} alt={title} />}   
                    {name && <p className='title'>{name} {title && <span>{title}</span>}</p>}
                    {content && <p>{content}</p>}
                </div>
            )}
            <div className='slider-dots'>
                {slides.map(({ name }, index) => 
                    <span
                        key={index} 
                        onClick={() => this.setState({ activeSlide: index })}
                        className={activeSlide === index ? 'active' : ''}
                    ></span>
                )}
            </div>
        </div>
    }
}

export default Slider


// WEBPACK FOOTER //
// ./src/components/Slider.js